import { styled } from '@mui/material/styles';
import ButtonGroup from '@mui/material/ButtonGroup';

import VpButton from '../VpButton';

export const StyledButtonGroup = styled(ButtonGroup)({
  margin: '-8px'
});
export const StyledVpButton = styled(VpButton)({
  gap: '10px',
  svg: {
    width: '15px'
  }
});



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpButtonGroup/styles.js